import React from 'react';
import moment from 'moment';
import { render } from 'react-dom';
import AppModal from './webcommon/common/modal/AppModal';
import * as appConstants from './common/constants';

if (process.env.NODE_ENV !== 'test') {
    AppModal.setAppElement('body');
}

const AgreeUsage = () => {
    const onClick = () => {
        localStorage.setItem('BIOTIC/USAGE_AGREED', moment().format(appConstants.dateFormat));
        window.location.reload();
    };

    return (
        <AppModal
            isOpen
            heading="Warning"
            message=" Unauthorised access, or usage of this service in breach of Rabobank's policies, is prohibited"
            submit="Accept"
            onButtonClick={ onClick }
        />
    );
};

render(
    <AgreeUsage />,
    document.getElementById('root')
);
